import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5 justify-content-center" }
const _hoisted_2 = { class: "col-12 col-md-8" }
const _hoisted_3 = { class: "row py-3" }
const _hoisted_4 = { class: "col-12 h1" }
const _hoisted_5 = { class: "text-uppercase fw-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_7 = { class: "col-12 col-md-8" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 h2 text-uppercase fw-bold" }, "Datos personales", -1)
const _hoisted_10 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Nombre:", -1)
const _hoisted_12 = { class: "h4" }
const _hoisted_13 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Apellido:", -1)
const _hoisted_15 = { class: "h4" }
const _hoisted_16 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Email:", -1)
const _hoisted_18 = { class: "h4" }
const _hoisted_19 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold" }, "Documento:", -1)
const _hoisted_21 = { class: "h4" }
const _hoisted_22 = { class: "col-12 col-md-6 my-1 p-2" }
const _hoisted_23 = { class: "fw-bold" }
const _hoisted_24 = { class: "h4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("hr")
], -1)
const _hoisted_26 = { class: "col-12 col-md-8" }

import FormVehiculosAsociados from '@/components/FormVehiculosAsociados.vue'
import { VuexStore } from '@/interfaces/VuexStore'
import { key } from '@/setup/store'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'MiCuenta',
  setup(__props) {

const { state } = useStore<VuexStore>(key)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" Hola, "),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(state).authUser?.nombre) + " " + _toDisplayString(_unref(state).authUser?.apellido), 1)
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(state).authUser?.nombre), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(state).authUser?.apellido), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(state).authUser?.email), 1)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(state).authUser?.documento ?? '--'), 1)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, "Miembro de " + _toDisplayString(_unref(state).evento?.nombre) + ":", 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(state).authUser?.fidelizado ? 'SI' : 'PENDIENTE DE VALIDACIÓN'), 1)
        ]),
        _hoisted_25
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createVNode(FormVehiculosAsociados)
    ])
  ]))
}
}

})